
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class CityAvatar extends Vue {
  @Prop({ required: true }) readonly adcode!: number
  @Prop({ required: true }) readonly cityName!: string

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
